import React from "react";
// import { useState } from "react";
import { NavLink } from "react-router-dom";
import "./NavBar.css";
// import logo_vt from '../assets/img/vt-stacked-official.jpg';
// import logo_carnations from '../assets/img/CARNATIONS text logo.png';
const s3BucketName = process.env.REACT_APP_S3_BUCKET;
const s3BucketUrl = `https://${s3BucketName}.s3.amazonaws.com`;

// Define the specific aws image paths
const logo_vt = `${s3BucketUrl}/vt-stacked-official.jpg`;
const logo_carnations = `${s3BucketUrl}/CARNATIONS text logo.png`;

// import { HamburgetMenuClose, HamburgetMenuOpen } from "./Icons";

function NavBar({ sidebar, toggleSidebar }) {
  // const [click, setClick] = useState(false);
  // const [sidebar, setSidebar] = useState(true);

  // const handleClick = () => setClick(!click);
  // const toggleSidebar = () => setSidebar(!sidebar);
  return (
    <>
      {/* <nav className="navbar"> */}
      {/* <nav className={click ? "navbar sidebar active" : "navbar sidebar"}> */}
      <nav className={`navbar ${sidebar ? 'sidebar' : 'sidebar-hidden'}`}>
        {/* <div className="toggle-button" onClick={toggleSidebar}>
          {sidebar ? <>&#9664;</> : <>&#9654;</>}
        </div> */}
        {sidebar ? (
          <div className="toggle-button" onClick={toggleSidebar}>
            {<>&#9664;</>}
          </div> 
        ):(
          <div className="toggle-button-hidden" onClick={toggleSidebar}>
            {<>&#9654;</>}
          </div>
        )}
        <div className="nav-container">
          {/* <NavLink exact to="/" className="nav-logo">
            <i className="fa-solid fa-satellite"></i>
          </NavLink> */}
          <ul className="nav-menu">
          <li className="nav-item">
              <NavLink
                exact
                to="/state"
                activeClassName="active"
                className="nav-links"
                // onClick={handleClick}
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                // to="/contact"
                to ="https://www.aoe.vt.edu/people/faculty/joerger/personal-page.html"
                activeClassName="active"
                className="nav-links"
                // onClick={handleClick}
              >
                Contact Us
              </NavLink>
            </li>
            
          </ul>
          {/* <div className="nav-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"}></i>

            {click ? (
              <span className="icon">
                <HamburgetMenuOpen />{" "}
              </span>
            ) : (
              <span className="icon">
                <HamburgetMenuClose />
              </span>
            )}
          </div> */}
          
        </div>
        <div className="nav-logo-container">
          <NavLink to="https://www.aoe.vt.edu/people/faculty/joerger/personal-page.html">
            <img src={logo_vt} alt="Logo" className="nav-logo-img" />
          </NavLink>
          <NavLink to="https://www.iitcarnations.org/">
            <img src={logo_carnations} alt="Carnations_Logo" className="nav-logo-img-2"/>
          </NavLink>
          {/* <NavLink to="https://www.transportation.gov/content/university-transportation-centers">
            <h4>USDOT University 
            Transportation Center</h4>
          </NavLink> */}
        </div>
      </nav>
    </>
  );
}

export default NavBar;